export default "__VITE_ASSET__DThtOejP__"